import { render } from "./ChambersMainList.vue?vue&type=template&id=34163e1e"
import script from "./ChambersMainList.vue?vue&type=script&lang=js"
export * from "./ChambersMainList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__